import Vue from 'vue'
import XButton from 'vux/src/components/x-button/index.vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


Vue.component('x-button', XButton)
Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)



// WEBPACK FOOTER //
// ./src/util/vux.js